import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setMeasurementUnitToImperial, setMeasurementUnitToMetric} from "../../Actions/Measurement.action";

const MeasurementSwitch = () => {
    const { measurementType } = useSelector((state) => state.measurement);
    
    const [value, setValue] = useState(parseInt(measurementType) === 1);

    const dispatch = useDispatch();

    function updateMeasurementUnit(value) {
        setValue(value);
        
        if(value === false){
            dispatch(setMeasurementUnitToMetric());
            return;
        }

        dispatch(setMeasurementUnitToImperial());
    }

    return (<div className="measurement-switch__container">
        <p className="measurement-switch__text">Metric</p>
        <label className="measurement-switch">
            <input className="measurement-switch__input" type="checkbox" checked={value} onChange={(e) => updateMeasurementUnit(e.target.checked)}/>
            <span className="measurement-switch__slider"></span>
        </label>
        <p className="measurement-switch__text">Imperial</p>
    </div>)
}

export default MeasurementSwitch;
